import Globals from '../Globals';

export default {
  ...Globals,

  primary: '#f18f01',
  primarySlightFade: '#ffae38',
  primaryFade: '#fff8de',
  primaryDarker: '#cb7a01',

  secondary: '#FEC60A',
};
